// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, objectToParams, retrieveToken } from "../../store/api";
import { JenisDokumenListResponse } from "./types";

import * as jenisDokumenActions from "./jenisDokumen.actions";

export function* getJenisDokumen(
  action: ReturnType<typeof jenisDokumenActions.getJenisDokumenAsync.request>
) {
  try {
    const payload = { status: action.payload.status };
    if (typeof action.payload.status === 'undefined') delete payload.status;
    
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}jenis-dokumen${objectToParams(payload)}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: JenisDokumenListResponse = yield call(result.json.bind(result));
      yield put(jenisDokumenActions.getJenisDokumenAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisDokumenActions.getJenisDokumenAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(jenisDokumenActions.getJenisDokumenAsync.failure(parsed));
  }
}

export default function* jenisDokumenSagaGetJenisDokumen() {
  yield takeEvery(jenisDokumenActions.getJenisDokumenAsync.request, getJenisDokumen);
}
